import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5241b4da&lang=pug&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports